module.exports = __webpack_public_path__ + "media/packs/src/assets/images/reporting-081bfeb5006a64ae9832f9561574b75a.png";